import store from '../store';

export function authenticationFailureInterceptor (error) {
    if (error.response.status === 401) {
        store.dispatch('authentication/clear');
        location.replace('/login');
        return;
    }
    return error;
}


export function getAuthorizationHeaders(token, access_token) {
    return {
        headers: {
            Authorization: `Bearer ${token}`,
            'x-access-token': access_token
        }
    };
}
